import toastr from "toastr";
import ajax from "@/common/ajax";

export default class EnrollmentsService {
    constructor() {
        this.url = "api/Enrollment/";
    }

    getTest(studentId) {
        return ajax.get(this.url + "GetTest", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    setTest(test) {
        return ajax.post(this.url + "SetTest", test).fail(response => toastr.error(response.responseJSON.message));
    }

    findVkUser(request) {
        return ajax.post(this.url + "FindVkUser", request).fail(response => toastr.error(response.responseJSON.message));
    }

    getUnusedFriendDiscounts(studentId, enrollmentId) {
        return ajax.get(this.url + "GetUnusedFriendDiscounts", { studentId, enrollmentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    getUnusedOverpaymentDiscount(enrollmentId) {
        return ajax.get(this.url + "GetUnusedOverpaymentDiscount", { enrollmentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    getEnrollments(request) {
        return ajax.get(this.url + "GetEnrollments", request).fail(response => toastr.error(response.responseJSON.message));
    }

    getLastCourseSubType(studentId) {
        return ajax.get(this.url + "GetLastCourseSubType", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    getStudentCityId(studentId) {
        return ajax.get(this.url + "GetStudentCityId", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    getCourseGroup(id) {
        return ajax.get(this.url + "GetCourseGroup", { id }).fail(response => toastr.error(response.responseJSON.message));
    }

    createCourseGroup(request) {
        return ajax.post(this.url + "CreateCourseGroup", request).fail(response => toastr.error(response.responseJSON.message));
    }

    updateCourseGroup(request) {
        return ajax.post(this.url + "UpdateCourseGroup", request).fail(response => toastr.error(response.responseJSON.message));
    }

    deleteCourseGroup(id) {
        return ajax.post(this.url + "DeleteCourseGroup", id).fail(response => toastr.error(response.responseJSON.message));
    }

    saveEnrollmentPayments(request) {
        return ajax.post(this.url + "SaveEnrollmentPayments", request).fail(response => toastr.error(response.responseJSON.message));
    }

    createEnrollment(request) {
        return ajax.post(this.url + "CreateEnrollment", request).fail(response => toastr.error(response.responseJSON.message));
    }

    updateEnrollment(request) {
        return ajax.post(this.url + "UpdateEnrollment", request).fail(response => toastr.error(response.responseJSON.message));
    }

    deleteEnrollment(id) {
        return ajax.post(this.url + "DeleteEnrollment", id).fail(response => toastr.error(response.responseJSON.message));
    }

    getTeachers() {
        return ajax.get(this.url + "GetTeachers").fail(response => toastr.error(response.responseJSON.message));
    }

    getHeadTeachers() {
        return ajax.get(this.url + "GetHeadTeachers").fail(response => toastr.error(response.responseJSON.message));
    }

    getStudentSources() {
        return ajax.get(this.url + "GetStudentSources").fail(response => toastr.error(response.responseJSON.message));
    }

    getCities() {
        return ajax.get(this.url + "GetCities").fail(response => toastr.error(response.responseJSON.message));
    }

    getCourseGroups() {
        return ajax.get(this.url + "GetCourseGroups").fail(response => toastr.error(response.responseJSON.message));
    }

    getMessagesTemplates() {
        return ajax.get(this.url + "GetMessagesTemplates").fail(response => toastr.error(response.responseJSON.message));
    }

    getDiscounts(studentId, enrollmentId) {
        return ajax.get(this.url + "GetDiscounts", { studentId, enrollmentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    checkExistingContacts(request) {
        return ajax.post(this.url + "CheckExistingContacts", request).fail(response => toastr.error(response.responseJSON.message));
    }

    downloadCourseGroupExcel(id) {
        window.open(this.url + "DownloadCourseGroupExcel?id=" + id, "_blank");
    }

    downloadCourseGroupRecommendationExcel(id) {
        window.open(this.url + "DownloadCourseGroupRecommendationExcel?id=" + id, "_blank");
    }

    downloadCourseGroupExcelForImport(id) {
        window.open(this.url + "DownloadCourseGroupExcelForImport?id=" + id, "_blank");
    }

    downloadCourseGroupPaymentsExcel(id) {
        window.open(this.url + "DownloadCourseGroupPaymentsExcel?id=" + id, "_blank");
    }

    downloadCourseGroupAttendanceFormExcel(id) {
        window.open(this.url + "DownloadCourseGroupAttendanceFormExcel?id=" + id, "_blank");
    }

    downloadCourseGroupFeedbackFormExcel(id) {
        window.open(this.url + "DownloadCourseGroupFeedbackFormExcel?id=" + id, "_blank");
    }

    downloadGroupListExcel(id) {
        window.open(this.url + "DownloadGroupListExcel?id=" + id, "_blank");
    }

    validateContract(enrollmentId) {
        return ajax.get(this.url + "ValidateContract", { enrollmentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    validateContracts(courseGroupId) {
        return ajax.get(this.url + "ValidateContracts", { courseGroupId }).fail(response => toastr.error(response.responseJSON.message));
    }

    validateStudentContracts(studentId) {
        return ajax.get(this.url + "ValidateStudentContracts", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    downloadDocxContract(enrollmentId) {
        window.open(this.url + "DownloadDocxContract?enrollmentId=" + enrollmentId, "_blank");
    }

    downloadPdfContract(enrollmentId) {
        window.open(this.url + "DownloadPdfContract?enrollmentId=" + enrollmentId, "_blank");
    }

    downloadGroupDocxContracts(courseGroupId) {
        window.open(this.url + "DownloadGroupDocxContracts?courseGroupId=" + courseGroupId, "_blank");
    }

    downloadStudentDocxContracts(studentId) {
        window.open(this.url + "DownloadStudentDocxContracts?studentId=" + studentId, "_blank");
    }

    downloadStudentPdfContracts(studentId) {
        window.open(this.url + "DownloadStudentPdfContracts?studentId=" + studentId, "_blank");
    }

    downloadGroupPdfContracts(courseGroupId) {
        window.open(this.url + "DownloadGroupPdfContracts?courseGroupId=" + courseGroupId, "_blank");
    }

    validateContactForCreateCertificate(enrollmentId, isStamp, lastName, firstName, middleName) {
        return ajax.get(this.url + "ValidateContactForCreateCertificate", { enrollmentId, isStamp, lastName, firstName, middleName }).fail(response => toastr.error(response.responseJSON.message));
    }

    validateGroupForCreateCertificates(courseGroupId, isStamp) {
        return ajax.get(this.url + "ValidateGroupForCreateCertificates", { courseGroupId, isStamp }).fail(response => toastr.error(response.responseJSON.message));
    }

    downloadPdfCertificate(enrollmentId, isStamp, lastName, firstName, middleName) {
        window.open(this.url + "DownloadPdfCertificate" + `?enrollmentId=${enrollmentId}&isStamp=${isStamp}&lastName=${lastName}&firstName=${firstName}&middleName=${middleName || ""}`, "_blank");
    }

    downloadGroupPdfCertificates(courseGroupId, isStamp) {
        window.open(this.url + "DownloadGroupPdfCertificates?courseGroupId=" + courseGroupId + "&isStamp=" + isStamp, "_blank");
    }

    setAddedToVk(request) {
        return ajax.post(this.url + "SetAddedToVk", request).fail(response => toastr.error(response.responseJSON.message));
    }

    setConfirmed(request) {
        return ajax.post(this.url + "SetConfirmed", request).fail(response => toastr.error(response.responseJSON.message));
    }

    setNotAnswered(request) {
        return ajax.post(this.url + "SetNotAnswered", request).fail(response => toastr.error(response.responseJSON.message));
    }

    setWasAtMeeting(request) {
        return ajax.post(this.url + "SetWasAtMeeting", request).fail(response => toastr.error(response.responseJSON.message));
    }

    getDoNotAddToRecommendationsValue(studentId) {
        return ajax.get(this.url + "GetDoNotAddToRecommendationsValue", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }

    getStudentType(studentId) {
        return ajax.get(this.url + "GetStudentType", { studentId }).fail(response => toastr.error(response.responseJSON.message));
    }
}